import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import PriceCalculator from "@heartinz/gst_india_product_price_calculator";
import TotalCalculator from "@heartinz/checkout_billing_price_validator";
import { CircularProgress, Tooltip } from "@mui/material";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import EditUpdateQty from "./EditUpdateQty";
import EditAlert from "./EditAlert";
// import { useAuth } from "../../../context/AuthProvider";
import ChangeModal from "./ChangeModal";
import EditService from "../service/EditService";
import CustomerModal from "./CustomerModal";
import EditRecharge from "../recharge/EditRecharge";
import UpdatePrice from "./UpdatePrice";
import { getLastRoute } from "../../../context/LocationTracker";
import DeleteModal from "../../../constants/DeleteModal";
import { usePermission } from "../../../context/PermissionContext";
import EditCutomer from "../customer/EditCustomer";
import ProductNoteModal from "./Note";
import { useContextApi } from "../../../context/ContextApi";
import SearchInput from "../../../constants/SearchInput";
import AddCustomer from "../customer/AddCustomer";
import ProductSearchList from "../../../constants/ProductSearchList";
import FindStock from "./FindStock";
import {
  distributeDiscountToItems,
  getAllPriceList,
  unitScale,
} from "@heartinz/finance";
import uRLs from "../../../utils/baseUtils";
import AddService from "../service/AddService";
import AddRecharge from "../recharge/AddRecharge";
import { getOS } from "../../../utils/getOs";
import ListFavouriteProduct from "./ListFavouriteProduct";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useAuth } from "../../../context/AuthProvider";
import ProjectSale from "./ProjectSale";
import PaymentMethod from "./PaymentMethod";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import { useSaleContext } from "../../../context/SaleContext";
import { capitalizeFirstLetter } from "../../../utils/print/a4Invoices/common/invoiceUtils";
import RemarkModal from "./Remark";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import {
  AddIcon,
  BarcodeIcon,
  CalendarIcon,
  CheckIcon,
  ChevronRightIcon,
  CircleIcon,
  DeleteIcon,
  EditIcon,
  LineDoubleIcon,
  MinusIcon,
  NotepadIcon,
  OfferIcon,
  RemoveIcon,
  SearchIcon,
  StarIcon,
  XIcon,
} from "../../../constants/Icons";

const EditSale = ({ onDone, isActive }) => {
  const { state } = useLocation();
  const backTo = getLastRoute() || "/";
  // const { isUser, isLoading, handleLogout } = useAuth();
  const { checkNetwork } = useNetwork();
  const {
    isSaleData,
    setSaleData,
    paymentModal,
    setPaymentModal,
    isSaleModalOpen,
    setSaleModalOpen,
  } = useSaleContext();
  const showAlert = useShowAlert();
  const [error, setErrors] = useState({});
  const { isUser, updateSettings } = useAuth();
  const {
    handleSuggestEstimate,
    estimateSuggest,
    handleSuggestService,
    serviceNameSuggest,
    setServiceNameSuggest,
    customerSearchTerm,
    customerSuggestions,
    setCustomerSearchTerm,
    isCustomerData,
    setCustomerData,
    handleCustomerSearch,
    setCustomerSuggestions,
  } = useContextApi();
  const navigate = useNavigate();

  //**************** Ref ******************//
  const suggestionRefs = useRef([]);
  const cashRef = useRef(null);
  const cardRef = useRef(null);
  const onlineRef = useRef(null);
  const upiRef = useRef(null);
  const paylaterRef = useRef(null);
  const buttonRef = useRef(null);

  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);
  const favouriteRefs = useRef([]);

  const [isPreLoading, setPreLoading] = useState(false);

  const [isBtnLoading, setBtnLoading] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [currentNoteProduct, setCurrentNoteProduct] = useState(null);

  const [isServiceModalOpen, setServiceModalOpen] = useState(false);
  const [isRecharageModalOpen, setRecharageModelOpen] = useState(false);

  //**************** Date ***************//
  const serverTime = GetServerLiveTime();

  const [saleDate, setSaleDate] = useState(dayjs());
  const [originalSaleDate, setOriginalSaleDate] = useState("");
  const maxDate = originalSaleDate
    ? dayjs(serverTime).endOf("day")
    : dayjs(serverTime).endOf("day");

  const minDate = originalSaleDate
    ? dayjs(serverTime).subtract(5, "month").startOf("day")
    : dayjs(serverTime).subtract(5, "month").startOf("day");

  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [saleDateApi, setSaleDateApi] = useState("");

  const [saleNo, setSaleNo] = useState(null);
  const [imode, setImode] = useState(null);

  const barcodeRef = useRef(null);
  const suggestionsRef = useRef(null);
  const [barcodeSearchTerm, setBarcodeSearchTerm] = useState("");
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [productSuggestions, setProductSuggestions] = useState([]);

  const [isProductModalOpen, setProductModalOpen] = useState(false);

  const [selectedOffer, setSelectedOffer] = useState(null);
  const [offerEnabled, setOfferEnabled] = useState(false);

  const [isFavouriteProductModel, setFavouriteProductModel] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [favouriteProducts, setFavouriteProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [shortcutKey, setShortcutKey] = useState("Ctrl + F");

  const [isStockModalOpen, setStockModalOpen] = useState(false);
  const [isStockData, setStockData] = useState(null);
  const [isSoldPirceModalOpen, setSoldPriceModalOpen] = useState(false);
  const [isProductData, setProductData] = useState(null);
  const [recentData, setRecentData] = useState([]);
  const [showProductDropdown, setShowProductDropdown] = useState(false);

  //**************** Cart ******************//
  const [saleid, setSaleId] = useState(null);
  const [isSaleEdit, setSaleEdit] = useState(false);
  const [ecart, setECart] = useState([]);
  // console.log(ecart);
  const [totalPayable, setTotalPayable] = useState(0);
  const [totalMRP, setTotalMRP] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalSaleprice, setTotalSalePrice] = useState(0);
  const [totalSoldprice, setTotalSoldPrice] = useState(0);
  const [totalTaxamount, setTotalTaxAmount] = useState(0);
  const [totalBaseprice, setTotalBasePrice] = useState(0);
  const [totalQty, setTotalQuantity] = useState(0);
  const [numberSuggest, setNumberSuggest] = useState([]);

  const [oldCash, setOldCash] = useState(null);
  const [oldCard, setOldCard] = useState(null);
  const [oldUpi, setOldUpi] = useState(null);
  const [oldPaylater, setOldPaylater] = useState(null);

  const [totalSaleRes, setSaleTotals] = useState(0);
  const [totalSoldRes, setSoldTotals] = useState(0);

  const [cash, setCash] = useState(0);
  const [card, setCard] = useState(0);
  const [upi, setUpi] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [paylater, setPaylater] = useState(0);
  const [online, setOnline] = useState(0);
  const [remineDiscount, setRemineDiscount] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [balance, setBalance] = useState(totalPayable);

  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [isChangeModalOpen, setChangeModalOpen] = useState(false);
  const [noteSuggest, setNoteSuggest] = useState([]);

  const [projectId, setProjectId] = useState("");
  const [resetProject, setResetProject] = useState(false);

  const [isEditServiceModalOpen, setEditServiceModalOpen] = useState(false);
  const [isServiceData, setServiceData] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [isEditSalePriceData, setEditSalePriceData] = useState(null);
  const [isEditSalePriceModelOpen, setEditSalePriceModelOpen] = useState(false);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [isEditRechargeData, setEditRechargeData] = useState(null);
  const [isEditRechargeModelOpen, setEditRechargeModelOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleteData, setDeleteData] = useState(null);
  const {
    permission,
    blockedPermissions,
    hasPermission,
    viewOption,
    customerGroups,
    hasModulePermission,
    globelPopupOpen,
    activeStoreModules,
    storeSettings,
  } = usePermission();
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const hasFetched = useRef(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [groupName, setGroupName] = useState(customerGroups);
  const originalItemsRef = useRef([]);
  const originalPayableRef = useRef(0);
  const skipNextGrandTotalChange = useRef(false);

  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const [isViewModalOpen, setViewModalOpen] = useState(false);

  const [overallDiscount, setOverallDiscount] = useState("");
  const [overallDiscountApplied, setOverallDiscountApplied] = useState(false);

  const [remark, setRemark] = useState("");
  const [remarkInput, setRemarkInput] = useState("");
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [showFullRemark, setShowFullRemark] = useState(false);
  const isInitialCartLoad = useRef(true);
  const isOverallDiscountRemoved = useRef(false);
  const hasApiOverallDiscount = useRef(false);
  const skipNextCartChange = useRef(false);

  const initialPaymentData = {
    cash: 0,
    card: 0,
    online: 0,
    upi: 0,
    paylater: 0,
    discount: 0,
    totalPaid: 0,
    balance: 0,
  };

  const [paymentData, setPaymentData] = useState(initialPaymentData);

  // const [paymentModal, setPaymentModal] = useState(false);
  const handlePaymentClose = () => {
    setPaymentData(initialPaymentData);
    setPaymentModal(false);
  };
  //*************** Default **************//

  const handleOutsideClick = (e) => {
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target) &&
      !isCustomerModalOpen
    ) {
      handleResetCustomer();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    hasApiOverallDiscount.current = !!state?.overallDiscount;
    isOverallDiscountRemoved.current = false;
    isInitialCartLoad.current = true;
    if (state?._id) {
      setSaleId(state._id);
    }
    if (state?.saleno) {
      setSaleNo(state.saleno);
    }
    if (state?.imode) {
      setImode(state.imode);
    }
    if (state?.saleto) {
      setCustomerData({
        customerData: {
          ...state.saleto,
        },
        paylaterData: state.paylaterData ?? null,
      });
      setSelectedCustomer({
        customerData: {
          ...state.saleto,
        },
        paylaterData: state.paylaterData ?? null,
      });
    }
    if (state?.saledate) {
      setSaleDate(dayjs(state.saledate));
      setSaleDateApi(state.saledate);
      setOriginalSaleDate(state.saledate);
    }
    if (state?.projectId) {
      setProjectId(state?.projectId._id);
    }
    if (state?.saleitems) {
      const updatedSaleItems = state.saleitems.map((item) => ({
        ...item,
        oldquantity: item.quantity,
        unit: item?.unitConfig?.primaryUnitCode,
      }));
      skipNextCartChange.current = true;
      setECart(updatedSaleItems);
      localStorage.setItem("nGbLecart", JSON.stringify(updatedSaleItems));
    } else {
      const savedCart = JSON.parse(localStorage.getItem("nGbLecart"));
      if (savedCart && Array.isArray(savedCart)) {
        setECart(savedCart);
      }
    }
    if (state?.cashamount) {
      setCash(CurrencyConverter.toCurrency(state.cashamount, "INR"));
    }
    if (state?.cardamount) {
      setCard(CurrencyConverter.toCurrency(state.cardamount, "INR"));
    }
    if (state?.onlineamount) {
      setOnline(CurrencyConverter.toCurrency(state.onlineamount, "INR"));
    }
    if (state?.upiamount) {
      setUpi(CurrencyConverter.toCurrency(state.upiamount, "INR"));
    }
    if (state?.paylateramount) {
      setPaylater(CurrencyConverter.toCurrency(state.paylateramount, "INR"));
    }
    if (state?.discountamount) {
      setDiscount(CurrencyConverter.toCurrency(state.discountamount, "INR"));
      setRemineDiscount(
        CurrencyConverter.toCurrency(state.discountamount, "INR"),
      );
    }
    if (state?.paidamount) {
      setTotalPaid(state.paidamount);
    }
    if (state?.paidamount) {
      setTotalPayable(state.paidamount);
    }
    if (state?.balance) {
      setBalance(CurrencyConverter.toCurrency(state.balance, "INR"));
    }
    if (state?.discountamount) {
      setDiscount(CurrencyConverter.toCurrency(state.discountamount, "INR"));
      setRemineDiscount(
        CurrencyConverter.toCurrency(state.discountamount, "INR"),
      );
    }
    // if (state?.overallDiscount) {
    //   setOverallDiscount(
    //     CurrencyConverter.toCurrency(
    //       state.overallDiscount.overallDiscountAmount,
    //       "INR",
    //     ),
    //   );

    //   setOverallDiscountApplied(true);

    //   originalItemsRef.current = state.saleitems.map((item, index) => {
    //     const previous = state.overallDiscount.previousItemDetails[index];

    //     return {
    //       ...item, // keep all existing fields
    //       soldprice: previous?.soldPrice ?? item.soldprice,
    //       quantity: previous?.quantity ?? item.quantity,
    //       lineTotalSoldPrice:
    //         previous?.lineTotalSoldPrice ?? item.lineTotalSoldPrice,
    //     };
    //   });
    // }
    setPaymentData({
      cash: CurrencyConverter.toCurrency(state?.cashamount || 0, "INR"),
      card: CurrencyConverter.toCurrency(state?.cardamount || 0, "INR"),
      online: CurrencyConverter.toCurrency(state?.onlineamount || 0, "INR"),
      upi: CurrencyConverter.toCurrency(state?.upiamount || 0, "INR"),
      paylater: CurrencyConverter.toCurrency(state?.paylateramount || 0, "INR"),
      totalPaid: state?.paidamount,
      balance: CurrencyConverter.toCurrency(state?.balance || 0, "INR"),
    });
    if (state?.remark) {
      setRemark(state.remark);
      setRemarkInput(state.remark);
    }
    setSaleEdit(state?._id);
  }, [state]);

  // console.log("originalItemsRef.current", originalItemsRef.current);

  useEffect(() => {
    localStorage.setItem("nGbLecart", JSON.stringify(ecart));
    calculateTotal();
  }, [ecart]);

  const handleSaleDate = (newValue) => {
    if (!newValue) return;

    setSaleDate(newValue);

    const saleDateApi = DateConverter.convertToTimeZone(
      newValue.toISOString(),
      isUser?.timezone,
    );
    setSaleDateApi(saleDateApi);
    setOpenDatePicker(false);
  };

  // console.log("ecart", ecart);

  const calculateTotal = () => {
    // var totalPay = ecart.reduce((total, item) => total + item.lineGrandTotal, 0);
    // setTotalPayable(CurrencyConverter.toCurrency(totalPay || 0, "INR"));

    var totalMrPrice = ecart.reduce(
      (total, item) => total + item.lineTotalMrp,
      0,
    );
    setTotalMRP(CurrencyConverter.toCurrency(totalMrPrice || 0, "INR"));

    // var totalDis = ecart.reduce((total, item) => total + item.lineTotalDiscount, 0);
    // setTotalDiscount(CurrencyConverter.toCurrency(totalDis || 0, "INR"));

    var totalSold = ecart.reduce(
      (total, item) => total + item.lineTotalSoldPrice,
      0,
    );
    setTotalSoldPrice(CurrencyConverter.toCurrency(totalSold || 0, "INR"));

    var totalSale = ecart.reduce(
      (total, item) => total + item.lineTotalSalePrice,
      0,
    );
    setTotalSalePrice(CurrencyConverter.toCurrency(totalSale || 0, "INR"));

    var totalBase = ecart.reduce(
      (total, item) => total + item.lineTotalBasePrice,
      0,
    );
    setTotalBasePrice(CurrencyConverter.toCurrency(totalBase || 0, "INR"));

    var totalTax = ecart.reduce(
      (total, item) => total + item.lineTotalTaxAmount,
      0,
    );
    setTotalTaxAmount(CurrencyConverter.toCurrency(totalTax || 0, "INR"));

    var totalQty = ecart.reduce((total, item) => total + item.quantity, 0);
    setTotalQuantity(totalQty);

    var totalSaleRes = PriceCalculator.getGrandTotal(
      totalMrPrice,
      totalSale,
      totalBase,
      totalTax,
    );
    var totalSoldRes = PriceCalculator.getGrandTotal(
      totalMrPrice,
      totalSold,
      totalBase,
      totalTax,
    );
    setSaleTotals(totalSaleRes);
    setSoldTotals(totalSoldRes);
    setTotalPayable(totalSoldRes.grandtotal);
  };

  // const handleFocusFill = (mode) => {
  //   const grandTotal = Number(
  //     CurrencyConverter.toCurrency(totalSoldRes.grandtotal || 0, "INR"),
  //   );

  //   const currentCash = Number(cash || 0);
  //   const currentCard = Number(card || 0);
  //   const currentUpi = Number(upi || 0);
  //   const currentonline = Number(online || 0);
  //   const currentPaylater = Number(paylater || 0);

  //   const totalAlreadyPaid =
  //     currentCash + currentCard + currentonline + currentUpi + currentPaylater;

  //   const remainingBalance = grandTotal - totalAlreadyPaid;

  //   if (remainingBalance <= 0) return;

  //   // Set untouched fields to 0 if they were empty
  //   if (!cash) setCash(0);
  //   if (!card) setCard(0);
  //   if (!upi) setUpi(0);
  //   if (!online) setOnline(0);
  //   if (!paylater) setPaylater(0);

  //   // Add remainingBalance to the selected mode
  //   if (mode === "cash") {
  //     setCash(currentCash + remainingBalance);
  //     setTimeout(() => cashRef?.current?.select(), 0);
  //   } else if (mode === "card") {
  //     setCard(currentCard + remainingBalance);
  //     setTimeout(() => cardRef?.current?.select(), 0);
  //   } else if (mode === "online") {
  //     setOnline(currentonline + remainingBalance);
  //     setTimeout(() => onlineRef?.current?.select(), 0);
  //   } else if (mode === "upi") {
  //     setUpi(currentUpi + remainingBalance);
  //     setTimeout(() => upiRef?.current?.select(), 0);
  //   } else if (mode === "paylater") {
  //     setPaylater(currentPaylater + remainingBalance);
  //     setTimeout(() => paylaterRef?.current?.select(), 0);
  //   }
  // };

  const handleFocusFill = (mode) => {
    const grandTotal = Number(
      CurrencyConverter.toCurrency(totalSoldRes.grandtotal || 0, "INR"),
    );

    setPaymentData((prev) => {
      const cash = Number(prev.cash || 0);
      const card = Number(prev.card || 0);
      const online = Number(prev.online || 0);
      const upi = Number(prev.upi || 0);
      const paylater = Number(prev.paylater || 0);

      const totalPaid = cash + card + online + upi + paylater;
      const remaining = grandTotal - totalPaid;

      if (remaining <= 0) return prev;

      const updated = {
        ...prev,
        cash: prev.cash || 0,
        card: prev.card || 0,
        online: prev.online || 0,
        upi: prev.upi || 0,
        paylater: prev.paylater || 0,
      };

      updated[mode] = Number(updated[mode]) + remaining;

      return updated;
    });

    const refs = {
      cash: cashRef,
      card: cardRef,
      online: onlineRef,
      upi: upiRef,
      paylater: paylaterRef,
    };

    setTimeout(() => {
      refs[mode]?.current?.select();
    }, 0);
  };

  const handleEnterFocus = (
    e,
    nextRef,
    mode,
    currentValue,
    nextMode,
    nextValue,
  ) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const numericValue = Number(currentValue || 0);
      const nextNumericValue = Number(nextValue || 0);

      // ✅ Prefill *next* input if it's empty (not current)
      if (nextMode && !nextNumericValue) {
        handleFocusFill(nextMode);
      }

      // Move to next input
      nextRef?.current?.focus();
    }
  };

  const updateQuantity = (productId, Uindex, newQty) => {
    if (newQty <= 0) {
      removeEItem(Uindex);
    }
    const product = ecart.find(
      (product) => product._id === productId && Uindex === isEditCartIndex,
    );
    if (product) {
      var oldQty = product.oldquantity;
    }
    setECart((prevCart) =>
      prevCart.map((item, index) => {
        if (item._id === productId && index === Uindex) {
          const enteredQty = parseInt(newQty);
          if (enteredQty > oldQty) {
            return {
              ...item,
              quantity: oldQty,
            };
          }
          if (enteredQty > 0 && enteredQty <= oldQty) {
            var saleRes = PriceCalculator.getAllPriceList(
              item.mrp,
              item.saleprice,
              item.baseprice,
              item.taxpercentage,
              enteredQty,
              item.isLock,
            );

            var soldRes = PriceCalculator.getAllPriceList(
              item.mrp,
              item.soldprice,
              item.baseprice,
              item.taxpercentage,
              enteredQty,
              "SALEPRICE",
            );

            return {
              ...item,
              baseprice: soldRes.basePrice,
              discount: soldRes.discount,
              taxamount: soldRes.taxAmount,
              quantity: enteredQty,
              lineGrandTotal: soldRes.lineGrandTotal,
              lineTotalBasePrice: soldRes.lineTotalBasePrice,
              lineTotalDiscount: soldRes.lineTotalDiscount,
              lineTotalMrp: soldRes.lineTotalMrp,
              lineTotalSalePrice: saleRes.lineTotalSalePrice,
              lineTotalSoldPrice: soldRes.lineTotalSalePrice,
              lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
            };
          }
        } else {
          return item;
        }
      }),
    );
  };

  const removeEItem = (indexToRemove) => {
    if (isSaleEdit) {
      setECart((prevCart) => {
        return prevCart.filter((_, index) => index !== indexToRemove);
      });
    } else {
      setAlertModalOpen(true);
    }
  };

  const [isQuantityModalOpen, setQuantityModalOpen] = useState(false);
  const [isQuantityData, setQunatityItem] = useState(null);
  const [isEditCartIndex, setEditCartIndex] = useState(null);

  const handleQuantity = async (item, Nindex) => {
    if (isSaleEdit) {
      setQuantityModalOpen(true);
      setQunatityItem(item);
      setEditCartIndex(Nindex);
    } else {
      setAlertModalOpen(true);
    }
  };

  const handleQuantityClose = () => {
    setQuantityModalOpen(false);
    setQunatityItem(null);
    setEditCartIndex(null);
  };

  const handleQuantityUpdate = async (item, Uindex, newQty) => {
    updateQuantity(item, Uindex, newQty);
    handleQuantityClose();
  };

  const handleAlertClose = () => {
    setAlertModalOpen(false);
  };

  const editSalePriceClose = () => {
    setEditSalePriceModelOpen(false);
  };

  const handleEditRechargeClose = () => {
    setEditRechargeModelOpen(false);
  };

  //*************** Customer **************//
  const customerSuggestionsRef = useRef(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);

  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);

  // const handleSelectCustomer = (customer) => {
  //   setSelectedCustomer(customer);
  //   handleResetCustomer();
  // };

  // console.log("originalSaleDate", originalSaleDate);
  // console.log("minDate", minDate.format("YYYY-MM-DD"));
  // console.log("maxDate", maxDate.format("YYYY-MM-DD"));

  const handleSelectCustomer = async (customer) => {
    try {
      if (!checkNetwork()) return;

      // Get customer id whether object or string
      const customerId =
        typeof customer === "string" ? customer : customer?._id;

      if (!customerId) {
        showAlert("warning", "Invalid customer");
        return;
      }

      const response = await AxiosInstance.get(
        `module/customer/details/${customerId}`,
      );

      const fullCustomer = response.data.results;

      setSelectedCustomer(fullCustomer);
      setCustomerData(fullCustomer);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);
      handleResetCustomer();
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const openEditModal = (cItem) => {
    if (
      blockedPermissions("CUSTOMER:viewDetails") ||
      permission === undefined
    ) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "phone",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "shippingaddressline1",
      "shippingaddressline2",
      "shippingstate",
      "shippingcity",
      "shippingdistrict",
      "shippingpincode",
      "shippingcountry",
      "website",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }

    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }

    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        shippingAddress: {
          addressline1: updatedData.shippingaddressline1,
          addressline2: updatedData.shippingaddressline2,
          district: updatedData.shippingdistrict,
          city: updatedData.shippingcity,
          state: updatedData.shippingstate,
          statecode: updatedData.shippingstatecode,
          country: updatedData.shippingcountry,
          pincode: updatedData.shippingpincode,
        },

        // ✅ Contact Person Object
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );
      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);
      setCustomerData(response.data.results);
      setSelectedCustomer((prev) => ({
        ...prev,
        customerData: response.data.results,
      }));
      closeEditModal();
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  //**************** Payment ***************//
  // const [isSaleModalOpen, setSaleModalOpen] = useState(false);
  const [data, setSaleDataEdit] = useState(null);

  const handleInputChange = (setValue) => (e) => {
    const value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setValue(value);
    } else {
      setValue(0);
    }
  };

  useEffect(() => {
    var cashAmt = CurrencyConverter.toSubunit(cash || 0, "INR");
    var cardAmt = CurrencyConverter.toSubunit(card || 0, "INR");
    var upiAmt = CurrencyConverter.toSubunit(upi || 0, "INR");
    var disAmt = CurrencyConverter.toSubunit(discount || 0, "INR");
    var onlineAmt = CurrencyConverter.toSubunit(online || 0, "INR");
    var paylaterAmt = CurrencyConverter.toSubunit(paylater || 0, "INR");
    var payObject = {
      cashamount: cashAmt,
      cardamount: cardAmt,
      onlineamount: onlineAmt,
      discountamount: disAmt,
      upiamount: upiAmt,
      paylateramount: paylaterAmt,
    };
    var totalVal = TotalCalculator.validateCheckout(totalPayable, payObject);
    setTotalPaid(totalVal.totalPaid);
    setBalance(totalVal.balance);
    // if (totalVal.balance < 0) {
    //   setPaylater(0);
    // }
  }, [cash, card, online, upi, discount, paylater, totalPayable]);

  const prevTotalPayable = useRef(totalPayable);

  useEffect(() => {
    if (totalPayable < prevTotalPayable.current) {
      if (paylater > 0) setOldPaylater(paylater);
      setPaylater(0);
    }
    prevTotalPayable.current = totalPayable;
  }, [totalPayable]);

  const handleCancel = () => {
    setECart([]);
    localStorage.removeItem("nGbLecart");
    setProjectId("");
    setResetProject((prev) => !prev);
    setCash(0);
    setCard(0);
    setOnline(0);
    setUpi(0);
    setDiscount(0);
    setPaylater(0);
    setTotalPaid(0);
    setBalance(0);
    setCustomerSearchTerm("");
    setCustomerSuggestions([]);
    setSelectedCustomer(null);
    handleResetAddCustomer();
    setOverallDiscount("");
    setOverallDiscountApplied(false);
    // navigate("/listsale", { replace: true });
  };

  const openDeleteModal = (cItem) => {
    if (blockedPermissions("SALE:delete") || permission === undefined) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDelete = async (saleId) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const idToDelete = saleId || isDeleteData._id;

      const response = await AxiosInstance.delete(`module/sale/${idToDelete}`);
      showAlert("success", Messages.SUCCESS.SALE_DELETED);
      navigate("/listSale");
      handleReset();
      if (isDeleteModalOpen) {
        closeDeleteModal();
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const closeDeleteModal = () => {
    setDeleteData(null);
    setDeleteModalOpen(false);
  };

  const fetchFavouriteProducts = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get("module/product/favourite");
      // Response shape: { results: [ { productIds: [...] } ] }
      const results = response.data?.results;
      setFavouriteProducts(results);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading(false);
    }
  };

  const handleListFavouriteProductOpen = () => {
    setFavouriteProductModel(true);
  };

  const handleListFavouriteProductClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setFavouriteProductModel(false);
  };

  const handleAddClick = async (index, productDetails) => {
    setFavouriteProductModel(false);
    setSelectedIndex(index);
    if (!productDetails) return;
    if (productDetails.isStock) {
      try {
        if (!checkNetwork()) return;
        const response = await AxiosInstance.get(
          `module/stock/grouped/${productDetails.productId}`,
        );
        const stockArray = response.data.results || [];
        const updatedStocks = stockArray.map((batch) => {
          const cartItem = ecart.find(
            (item) =>
              item._id === productDetails.productId &&
              Number(item.mrp) === Number(batch.stockData?.mrp) &&
              Number(item.saleprice) === Number(batch.stockData?.saleprice) &&
              Number(item.taxpercentage) ===
                Number(batch.stockData?.taxpercentage),
          );
          // console.log("cartItem", cartItem);
          const oldQuantity = Number(cartItem?.oldquantity || 0);

          return {
            ...batch,
            totalStockLeft: Number(batch.totalStockLeft || 0) + oldQuantity,
          };
        });
        const stockWithNote = updatedStocks.map((stock) => ({
          ...stock,
          note: productDetails.note || "",
        }));
        setStockData(stockWithNote);
        setStockModalOpen(true);
        setRecentData([]);
      } catch (error) {
        handleError(error, showAlert);
      } finally {
        setProductSearchTerm("");
        setProductSuggestions([]);
      }
    } else {
      setSoldPriceModalOpen(true);
      setProductData(productDetails);
    }
  };

  const handleUpdate = async (paymentData) => {
    const savedCart = localStorage.getItem("nGbLecart");
    const saleItems = Array.isArray(savedCart)
      ? savedCart
      : JSON.parse(savedCart);
    const totalpaid = Number(paymentData.totalPaid || 0);
    const payLater = Number(paymentData.paylater || 0);
    if (!saleItems || saleItems.length <= 0) {
      openDeleteModal(state);
      return;
    }

    if (
      viewOption("saleSettings", "isCustomerMandatory") &&
      !selectedCustomer
    ) {
      showAlert("error", "Customer is mandatory for this sale");
      customerSuggestionsRef.current?.focus();
      return;
    }
    // if (!saleItems || saleItems.length === 0) {
    //   showAlert("warning", Messages.ERROR.EMPTY_CART);
    //   return;
    // }
    if (payLater > 0 && !selectedCustomer) {
      showAlert("error", Messages.ERROR.PAYLATER_ERROR);
      customerSuggestionsRef.current?.focus();
      return;
    }
    if (totalPayable === totalpaid) {
      handleUpdateSale();
    } else if (totalpaid > totalPayable) {
      setChangeModalOpen(true);
    } else {
      cashRef.current?.focus();
      showAlert("warning", Messages.ERROR.INVALID_PAID_AMOUNT);
    }
  };

  const handleOfferSelect = (value) => {
    if (!viewOption("saleSettings", "isOffer")) return;
    if (!offerEnabled) return;
    if (!value) return;

    const offer = Number(value);

    setSelectedOffer(offer);

    localStorage.setItem("selectedOffer", offer);

    const dropdown = document.querySelector(".dropdown-menu.show");
    if (dropdown) {
      dropdown.classList.remove("show");
    }
  };

  const handleSuggestNote = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/note/suggestion?language=en`,
      );

      setNoteSuggest(response.data.results || []);
      // setShowNotePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleRemoveCustomer = () => {
    setSelectedCustomer(null);
    setCustomerSearchTerm("");
    setCustomerSuggestions([]);
    setShowCustomerDropdown(false);
  };

  const handleChangeModalClose = () => {
    setChangeModalOpen(false);
  };

  const handleChangeConfirm = (changeData) => {
    if (changeData.changeamount !== 0) {
      setPaylater(0);
    }
    if (
      (paylater > 0 || changeData.paylaterchange > 0) &&
      !selectedCustomer?.customerData._id
    ) {
      showAlert("warning", Messages.ERROR.CUSTOMER_EMPTY);
      return false;
    }
    setChangeModalOpen(false);
    handleUpdateSale(changeData);
  };

  // console.log("saleDate", saleDate);

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleClose = () => {
    setSaleModalOpen(false);
    setSaleDataEdit(null);
    onDone?.();
  };

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewModalOpen(false);
      setSaleModalOpen(true);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleUpdateSale = async (changeData = {}) => {
    const savedCart = localStorage.getItem("nGbLecart");
    const parsedCart = Array.isArray(savedCart)
      ? savedCart
      : JSON.parse(savedCart);

    // const saleItems = parsedCart.map((item) => ({
    //   _id: item._id,
    //   code: item.code,
    //   hsnsac: item.hsnsac || "",
    //   title: item.title,
    //   mrp: item.mrp,
    //   saleprice: item.saleprice,
    //   soldprice: item.soldprice,
    //   taxpercentage: item.taxpercentage,
    //   baseprice: item.baseprice,
    //   isLock: item.isLock,
    //   isStock: item.isStock,
    //   quantity: item.quantity,
    //   description: item.description || "",
    //   imode: item.imode,
    //   walletid: item.walletid || "",
    //   operator: item.operator || "",
    //   number: item.number || "",
    //   itemNo: item.itemNo || "",
    //   note: item.note || "",
    //   serviceByName: item.serviceByName || "",
    // }));

    const saleItems = parsedCart.map((item) => {
      const commonFields = {
        title: item.title,
        hsnsac: item.hsnsac || "",
        description: item.description || "",
        mrp: item.mrp,
        saleprice: item.saleprice,
        soldprice: item.soldprice,
        taxpercentage: item.taxpercentage,
        baseprice: item.baseprice,
        isLock: "SALEPRICE",
        isStock: item.isStock,
        quantity: item.quantity,
        note: item.note || "",
        imode: item.imode,

        ...(item.stockLinkId && {
          stockLinkId: item.stockLinkId,
        }),
        ...(item.itemNo && {
          itemNo: item.itemNo,
        }),
        ...(item.unitConfig && {
          unitLocked: true,
          unitConfig: item.unitConfig,
        }),
      };

      if (item.imode === "SERVICE") {
        return {
          serviceId: item._id,
          serviceByName: item.serviceByName || "",
          ...commonFields,
        };
      }

      if (item.imode === "RECHARGE") {
        return {
          walletid: item.walletid || "",
          operator: item.operator || "",
          number: item.number || "",
          ...commonFields,
        };
      }

      // PRODUCT (default)
      return {
        _id: item._id,
        code: item.code,
        ...commonFields,
      };
    });

    var saleData = {
      saleid: saleid,
      customerid: selectedCustomer?.customerData._id ?? "",
      ...(remark && remark.trim() !== "" && { remark }),
      // imode: imode,
      saleitems: saleItems,
      ...(projectId && { projectId: projectId }),
      // totalqty: totalQty,
      // totalmrp: totalSoldRes.totalmrp,
      // totalsaleprice: totalSaleRes.totalsaleprice,
      // totalsoldprice: totalSoldRes.totalsaleprice,
      // totalbaseprice: totalSoldRes.totalbaseprice,
      // totaldiscount: totalSoldRes.totaldiscount,
      // totaltaxamount: totalSoldRes.totaltaxamount,
      // grandtotal: totalSoldRes.grandtotal,
      // sgstamount: totalSoldRes.sgstamount,
      // cgstamount: totalSoldRes.cgstamount,
      // igstamount: totalSoldRes.igstamount,
      // amountinwords: totalSoldRes.amountinwords,
      waveoffamount: 0,
      cashamount: CurrencyConverter.toSubunit(cash || 0, "INR"),
      cardamount: CurrencyConverter.toSubunit(card || 0, "INR"),
      upiamount: CurrencyConverter.toSubunit(upi || 0, "INR"),
      // discount: CurrencyConverter.toSubunit(discount || 0, "INR"),
      paylateramount: CurrencyConverter.toSubunit(paylater || 0, "INR"),
      // paidamount: totalPaid,
      cardchange: 0,
      onlinechange: 0,
      onlineamount: CurrencyConverter.toSubunit(online || 0, "INR"),
      changeamount: CurrencyConverter.toSubunit(
        changeData.changeamount || 0,
        "INR",
      ),
      waveoffchange: CurrencyConverter.toSubunit(
        changeData.wavedoffchange || 0,
        "INR",
      ),
      cashchange: CurrencyConverter.toSubunit(
        changeData.cashchange || 0,
        "INR",
      ),
      upichange: CurrencyConverter.toSubunit(changeData.upichange || 0, "INR"),
      paylaterchange: CurrencyConverter.toSubunit(
        changeData.paylaterchange || 0,
        "INR",
      ),
    };
    const discountAmount = Number(overallDiscount || 0);

    if (overallDiscountApplied && discountAmount > 0) {
      saleData.overallDiscount = {
        overallDiscountAmount: CurrencyConverter.toSubunit(
          discountAmount,
          "INR",
        ),
        previousItemDetails: originalItemsRef.current.map((item) => ({
          soldPrice: item.soldprice,
          quantity: item.quantity,
          lineTotalSoldPrice: item.lineTotalSoldPrice,
        })),
      };
    }
    if (saleDateApi && saleDateApi !== originalSaleDate) {
      saleData.saledate = saleDateApi;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      var data = saleData;
      var saleResp = await AxiosInstance.patch(`module/sale/`, data);
      showAlert("success", Messages.SUCCESS.SALE_UPDATED);
      handleReset();
      // navigate(backTo, {
      //   state: {
      //     modalData: { ...saleResp.data.results },
      //   },
      // });
      setPaymentModal(false);
      setSaleModalOpen(true);
      setViewModalOpen(true);
      setSaleDataEdit(saleResp.data.results);
      const updatedSale = saleResp.data.results;

      setSaleData((prev) =>
        prev.map((item) => (item._id === updatedSale._id ? updatedSale : item)),
      );
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleReset = () => {
    handleCancel();
  };

  const handleBarcodeSearch = async (code) => {
    setBarcodeSearchTerm(code);

    if (code.trim() === "") return; // skip if empty

    try {
      setPreLoading(true);
      if (!checkNetwork()) return;

      const response = await AxiosInstance.get(
        `module/product/code?code=${code}`,
      );

      const product = response.data.results;

      if (product) {
        // Directly handle selection — no suggestions list
        handleSelectProduct(product);
      } else {
        showAlert("warning", "No product found for this barcode");
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBarcodeSearchTerm(""); // clear after scan
      setPreLoading(false);
    }
  };

  const handleProductSearch = (term) => {
    if (term.trim() === "") {
      setProductSuggestions([]);
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;

        setPreLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;

        const response = await AxiosInstance.get(
          `module/product/search-hybrid-active?searchtxt=${term}`,
          { signal: controllerRef.current.signal },
        );

        if (currentId === requestIdRef.current) {
          // ✅ Remove duplicate barcode values
          const uniqueSuggestions = (response.data.results || []).filter(
            (item, index, self) =>
              index ===
              self.findIndex(
                (p) => p.code?.toString() === item.code?.toString(),
              ),
          );

          setProductSuggestions(uniqueSuggestions);
          setHighlightedIndex(0);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setPreLoading(false);
      }
    }, 200);
  };

  const handleProductClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setProductModalOpen(false);
  };

  const handleSelectProduct = async (product, fromModal = false) => {
    try {
      setProductSearchTerm("");
      setProductSuggestions([]);

      const response = await AxiosInstance.get(
        `module/product/view-product/${product._id}`,
      );
      const productDetails = response.data.results;

      if (productDetails.isStock) {
        handleStock(productDetails);
      } else {
        setSoldPriceModalOpen(true);
        setProductData(productDetails);
      }

      // ✅ close only if it was selected from modal
      if (fromModal) {
        setProductSearchTerm("");
        handleProductClose();
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleStock = async (product) => {
    try {
      if (!checkNetwork()) return;

      // Find the existing item in ecart
      const cartItem = ecart.find((item) => item._id === product._id);
      const hasCartStockLinkId = ecart.some((item) => !!item?.stockLinkId);

      // Use product stockLinkId first, otherwise ecart stockLinkId
      const stockLinkId = cartItem?.stockLinkId;

      const hasStockLinkId = !!hasCartStockLinkId;

      const endpoint = hasStockLinkId
        ? `module/stock/${product._id}`
        : `module/stock/grouped/${product._id}`;

      const response = await AxiosInstance.get(endpoint);

      let stockArray = response.data.results || [];

      // ---------------------------------------------------------
      // INDIVIDUAL STOCK
      // product.stockLinkId OR ecart.stockLinkId exists
      // ---------------------------------------------------------
      if (hasStockLinkId) {
        stockArray = stockArray.map((item) => ({
          totalStockLeft: Number(item.stockLeft || 0),
          totalStockLeftUnit: item.stockLeftUnit,
          note: product.note || "",
          isStockList: true,
          landingcost: item.landingcost,
          stockLinkId: item.stockLinkId,

          stockData: {
            productid: item.productid,
            saleprice: item.saleprice,
            mrp: item.mrp,
            taxpercentage: item.taxpercentage,
            discount: item.discount,
            baseprice: item.baseprice,
            taxamount: item.taxamount,
            isLock: item.isLock,

            productData: {
              code: item.code,
              hsnsac: item.hsnsac,
              title: item.title,
              unitConfig: item.unitConfig,
            },
          },
        }));
      }

      // ---------------------------------------------------------
      // GROUPED STOCK
      // Neither product nor ecart has stockLinkId
      // ---------------------------------------------------------
      else {
        const updatedStocks = stockArray.map((batch) => {
          const matchedCartItem = ecart.find(
            (item) =>
              item._id === product._id &&
              Number(item.mrp) === Number(batch.stockData?.mrp) &&
              Number(item.saleprice) === Number(batch.stockData?.saleprice) &&
              Number(item.taxpercentage) ===
                Number(batch.stockData?.taxpercentage),
          );

          const oldQuantity = Number(matchedCartItem?.oldquantity || 0);

          return {
            ...batch,
            totalStockLeft: Number(batch.totalStockLeft || 0) + oldQuantity,
          };
        });

        stockArray = updatedStocks.map((stock) => ({
          ...stock,
          note: product.note || "",
          isGroupedStock: true,
        }));
      }

      setStockData(stockArray);
      setStockModalOpen(true);
      setRecentData([]);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setProductSearchTerm("");
      setProductSuggestions([]);
    }
  };

  const handleBarcodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (barcodeSearchTerm.trim() === "") {
        // Move to product search if barcode is empty
        suggestionsRef.current?.focus();
      } else {
        // Perform barcode search
        handleBarcodeSearch(barcodeSearchTerm);
      }
    }
  };

  const handleProductKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, productSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      if (productSearchTerm.trim() === "") {
        customerSuggestionsRef.current?.focus();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = productSuggestions[highlightedIndex];
        handleSelectProduct(selected);
        setShowProductDropdown(false);
        setProductSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  const handleSoldPriceClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setSoldPriceModalOpen(false);
  };

  const handleStockClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setStockModalOpen(false);
    setStockData(null);
  };

  const salepriceEdit = async (cItem, index) => {
    console.log("salepriceEdit", cItem, index);
    try {
      const hasItemNo = !!cItem.itemNo;
      let editData = {
        ...cItem,
        cIndex: index,
        ...(hasItemNo ? { cMode: "EDIT" } : {}),
      };

      // ---------------------------------------------------------
      // 1. NON-STOCK PRODUCT
      // ---------------------------------------------------------
      if (!cItem.isStock) {
        const response = await AxiosInstance.get(
          `module/product/view-product/${cItem._id}`,
        );

        const productData = response?.data?.results;

        editData = {
          ...editData,
          landingcost: productData?.landingcost ?? 0,
        };
      }

      // ---------------------------------------------------------
      // 2. STOCK PRODUCT + stockLinkId
      //    Get landingcost from individual stock API
      // ---------------------------------------------------------
      else if (cItem.isStock && cItem.stockLinkId) {
        const response = await AxiosInstance.get(`module/stock/${cItem._id}`);

        const stockData = response?.data?.results || [];

        const matchedStock = stockData.find(
          (stock) => String(stock.stockLinkId) === String(cItem.stockLinkId),
        );
        const stockLeft = Number(matchedStock.stockLeft || 0);
        const oldqty = Number(cItem.oldquantity || 0);
        const cartQty = ecart
          .filter(
            (item) =>
              item._id === cItem._id &&
              Number(item.mrp) === Number(cItem.mrp) &&
              Number(item.saleprice) === Number(cItem.saleprice) &&
              Number(item.taxpercentage) === Number(cItem.taxpercentage),
          )
          .reduce((sum, item) => sum + Number(item.quantity || 0), 0);

        editData = {
          ...editData,
          stockLeft,
          editableStock: stockLeft === cartQty ? stockLeft : stockLeft + oldqty,
          landingcost: matchedStock?.landingcost ?? 0,
        };
      }

      // ---------------------------------------------------------
      // 3. STOCK PRODUCT + itemNo
      //    Existing grouped stock logic
      // ---------------------------------------------------------
      else if (cItem.isStock && hasItemNo) {
        const response = await AxiosInstance.get(
          `module/stock/grouped/${cItem._id}`,
        );

        const groupedStocks = response?.data?.results || [];

        const matchedBatch = groupedStocks.find(
          (batch) =>
            Number(batch.stockData?.mrp) === Number(cItem.mrp) &&
            Number(batch.stockData?.saleprice) === Number(cItem.saleprice) &&
            Number(batch.stockData?.taxpercentage) ===
              Number(cItem.taxpercentage),
        );

        if (matchedBatch) {
          const stockLeft = Number(matchedBatch.totalStockLeft || 0);
          const oldqty = Number(cItem.oldquantity || 0);

          const cartQty = ecart
            .filter(
              (item) =>
                item._id === cItem._id &&
                Number(item.mrp) === Number(cItem.mrp) &&
                Number(item.saleprice) === Number(cItem.saleprice) &&
                Number(item.taxpercentage) === Number(cItem.taxpercentage),
            )
            .reduce((sum, item) => sum + Number(item.quantity || 0), 0);

          editData = {
            ...editData,
            stockLeft,
            editableStock:
              stockLeft === cartQty ? stockLeft : stockLeft + oldqty,

            // grouped API landingcost
            landingcost:
              matchedBatch.stockData?.landingcost ??
              matchedBatch.landingcost ??
              0,
          };
        }
      }

      setEditSalePriceData(editData);
      setEditSalePriceModelOpen(true);
    } catch (error) {
      console.error("Failed to fetch stock/product data:", error);

      // Still open the modal with the original data
      setEditSalePriceData({
        ...cItem,
        cIndex: index,
        ...(cItem.itemNo ? { cMode: "EDIT" } : {}),
      });

      setEditSalePriceModelOpen(true);
    }
  };

  const RechargeEdit = async (cItem, index) => {
    setEditRechargeData({
      ...cItem,
      amount: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
      operator: cItem.operator,
      number: cItem.number,
      wallet: cItem.rechargeInfo.wallet.walletname,
      note: cItem.description,
      walletId: cItem.walletid,
      cIndex: index,
    });
    setEditRechargeModelOpen(true);
  };

  const editItem = async (cItem, index) => {
    setServiceData({
      ...cItem,
      mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
      saleprice: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
      discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
      baseprice: CurrencyConverter.toCurrency(cItem.baseprice, "INR"),
      taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
      cIndex: index,
    });
    // await handleSuggestEstimate();
    setEditServiceModalOpen(true);
  };

  const handleProductNote = (item) => {
    setCurrentNoteProduct(item);
    setNoteModalOpen(true);
  };

  const handleProductNoteClose = () => {
    setNoteModalOpen(false);
    setCurrentNoteProduct(null);
  };
  const saveProductNote = (note) => {
    if (!currentNoteProduct) return;

    setECart((cart) =>
      cart.map((item) =>
        item._id === currentNoteProduct._id ? { ...item, note } : item,
      ),
    );

    handleProductNoteClose();
  };

  const addProductToCart = (product, qty, cMode) => {
    if (cMode === "EDIT") {
      editSalePriceClose();
    } else {
      handleStockClose();
      handleSoldPriceClose();
    }

    setECart((prevCart) => {
      const allowDecimal = product.unitConfig && uRLs?.UNIT === "true";

      let updatedQuantity = allowDecimal
        ? Math.max(0.001, parseFloat(qty) || 0)
        : Math.max(1, parseInt(qty) || 0);

      if (product.isStock && typeof product.stockLeft === "number") {
        updatedQuantity = Math.min(updatedQuantity, product.stockLeft);
      }

      let primaryQty = updatedQuantity;
      let secondaryQty = updatedQuantity;

      if (product.unitConfig && uRLs?.UNIT === "true") {
        const scaleRes = unitScale(
          updatedQuantity,
          product.unitConfig,
          product.secondaryUnitSelected ? true : undefined,
        );

        primaryQty = scaleRes.primaryQty;
        secondaryQty = scaleRes.secondaryQty;
      }

      let displayUnit = "";
      let displayQty = primaryQty;

      if (product.unitConfig) {
        if (product.secondaryUnitSelected) {
          displayUnit = product.unitConfig.secondaryUnitCode;
          displayQty = secondaryQty;
        } else {
          displayUnit = product.unitConfig.primaryUnitCode;
          displayQty = primaryQty;
        }
      }

      const getUpdatedItem = (
        itemProduct,
        quantity,
        qtyDisplay,
        unitDisplay,
      ) => {
        const updatedSoldRes = PriceCalculator.getAllPriceList(
          itemProduct.mrp,
          itemProduct.soldprice,
          itemProduct.baseprice,
          itemProduct.taxpercentage,
          quantity,
          "SALEPRICE",
        );

        const updatedSaleRes = PriceCalculator.getAllPriceList(
          itemProduct.mrp,
          itemProduct.saleprice,
          itemProduct.baseprice,
          itemProduct.taxpercentage,
          quantity,
          itemProduct.isLock,
        );

        return {
          ...itemProduct,
          soldprice: itemProduct.soldprice,
          baseprice: updatedSoldRes.basePrice,
          discount: updatedSoldRes.discount,
          taxamount: updatedSoldRes.taxAmount,
          quantity: qtyDisplay,
          unit: unitDisplay,
          lineGrandTotal: updatedSoldRes.lineGrandTotal,
          lineTotalBasePrice: updatedSoldRes.lineTotalBasePrice,
          lineTotalDiscount: updatedSoldRes.lineTotalDiscount,
          lineTotalMrp: updatedSoldRes.lineTotalMrp,
          lineTotalSalePrice: updatedSaleRes.lineTotalSalePrice,
          lineTotalSoldPrice: updatedSoldRes.lineTotalSalePrice,
          lineTotalTaxAmount: updatedSoldRes.lineTotalTaxAmount,
          note: itemProduct.note || "",
        };
      };
      // console.log("updatefunction", getUpdatedItem);

      // ====================================
      // EDIT USING cIndex
      // ====================================
      if (
        typeof product.cIndex === "number" &&
        prevCart[product.cIndex] &&
        prevCart[product.cIndex]._id === product._id &&
        prevCart[product.cIndex].mrp === product.mrp &&
        prevCart[product.cIndex].saleprice === product.saleprice &&
        prevCart[product.cIndex].taxpercentage === product.taxpercentage
      ) {
        return prevCart.map((item, index) =>
          index === product.cIndex
            ? getUpdatedItem(product, primaryQty, displayQty, displayUnit)
            : item,
        );
      }

      // ====================================
      // PRODUCT ALREADY EXISTS
      // ====================================
      const existingProductIndex = prevCart.findIndex(
        (item) =>
          item._id === product._id &&
          item.mrp === product.mrp &&
          item.saleprice === product.saleprice &&
          item.taxpercentage === product.taxpercentage,
      );

      if (existingProductIndex !== -1) {
        const item = prevCart[existingProductIndex];

        let newQuantity = Number(item.quantity || 0) + Number(primaryQty || 0);

        if (product.isStock && typeof product.stockLeft === "number") {
          newQuantity = Math.min(newQuantity, product.stockLeft);
        }

        let mergedDisplayQty = newQuantity;

        if (product.unitConfig && uRLs?.UNIT === "true") {
          const scaleRes = unitScale(
            newQuantity,
            product.unitConfig,
            product.secondaryUnitSelected ? true : undefined,
          );

          mergedDisplayQty = product.secondaryUnitSelected
            ? scaleRes.secondaryQty
            : scaleRes.primaryQty;
        }

        const mergedProduct = {
          ...item,
          unit: displayUnit,
        };
        return prevCart.map((cartItem, index) =>
          index === existingProductIndex
            ? getUpdatedItem(
                mergedProduct,
                newQuantity,
                mergedDisplayQty,
                displayUnit,
              )
            : cartItem,
        );
      }

      // ====================================
      // ADD NEW PRODUCT
      // ====================================
      const saleRes = PriceCalculator.getAllPriceList(
        product.mrp,
        product.saleprice,
        product.baseprice,
        product.taxpercentage,
        primaryQty,
        product.isLock,
      );

      const soldRes = PriceCalculator.getAllPriceList(
        product.mrp,
        product.soldprice,
        product.baseprice,
        product.taxpercentage,
        primaryQty,
        "SALEPRICE",
      );

      return [
        ...prevCart,
        {
          ...product,
          soldprice: product.soldprice,
          baseprice: soldRes.basePrice,
          discount: soldRes.discount,
          taxamount: soldRes.taxAmount,
          quantity: displayQty,
          unit: displayUnit,
          imode: "PRODUCT",
          lineGrandTotal: soldRes.lineGrandTotal,
          lineTotalBasePrice: soldRes.lineTotalBasePrice,
          lineTotalDiscount: soldRes.lineTotalDiscount,
          lineTotalMrp: soldRes.lineTotalMrp,
          lineTotalSalePrice: saleRes.lineTotalSalePrice,
          lineTotalSoldPrice: soldRes.lineTotalSalePrice,
          lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
          note: product.note || "",
        },
      ];
    });
  };

  const handleServiceOpen = async () => {
    // await handleSuggestEstimate();
    setServiceModalOpen(true);
  };

  const handleServiceClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setServiceModalOpen(false);
  };

  const handleEditServiceClose = () => {
    setEditServiceModalOpen(false);
  };

  const UpdateServiceToCart = (citem, qty, cMode) => {
    // console.log("citem", citem);
    if (cMode === "EDIT") {
      handleEditServiceClose();
    } else if (cMode === "ADD") {
      handleServiceClose();
    }

    setECart((prevCart) => {
      const existingIndex = prevCart.findIndex(
        (item) => item.itemNo === citem.itemNo,
      );

      const updatedQuantity = Math.max(1, Number(qty));

      const saleRes = PriceCalculator.getAllPriceList(
        citem.mrp,
        citem.saleprice,
        citem.baseprice,
        citem.taxpercentage,
        updatedQuantity,
        citem.isLock,
      );

      const soldRes = PriceCalculator.getAllPriceList(
        citem.mrp,
        citem.soldprice,
        citem.baseprice,
        citem.taxpercentage,
        updatedQuantity,
        "SALEPRICE",
      );

      const serviceItem = {
        ...citem,
        quantity: updatedQuantity,
        baseprice: soldRes.basePrice,
        discount: soldRes.discount,
        taxamount: soldRes.taxAmount,
        lineGrandTotal: soldRes.lineGrandTotal,
        lineTotalBasePrice: soldRes.lineTotalBasePrice,
        lineTotalDiscount: soldRes.lineTotalDiscount,
        lineTotalMrp: soldRes.lineTotalMrp,
        lineTotalSalePrice: saleRes.lineTotalSalePrice,
        lineTotalSoldPrice: soldRes.lineTotalSalePrice,
        lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
      };

      if (cMode === "EDIT") {
        const existingIndex = prevCart.findIndex((item) =>
          citem.uniqueId
            ? item.uniqueId === citem.uniqueId
            : item.itemNo === citem.itemNo,
        );

        if (existingIndex !== -1) {
          return prevCart.map((item, index) =>
            index === existingIndex
              ? {
                  ...serviceItem,
                  uniqueId: item.uniqueId,
                  itemNo: item.itemNo,
                }
              : item,
          );
        }

        return prevCart;
      }

      // ADD mode - always add as a new row
      return [
        ...prevCart,
        {
          ...serviceItem,
          uniqueId: crypto.randomUUID(), // optional, for React key/editing later
        },
      ];
    });
  };

  const handleRechargeOpen = async () => {
    setRecharageModelOpen(true);
  };

  const handleRechargeClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setRecharageModelOpen(false);
  };

  const addRechargeToCart = (rechargeData) => {
    const quantity = 1;
    const amount = parseFloat(rechargeData.amount || 0);
    const subunitAmount = CurrencyConverter.toSubunit(amount.toFixed(2), "INR");

    const priceResult = PriceCalculator.getAllPriceList(
      subunitAmount,
      subunitAmount,
      subunitAmount,
      0,
      quantity,
      "SALEPRICE",
    );

    const newRecharge = {
      imode: "RECHARGE",
      isLock: rechargeData.isLock,
      isStock: false,
      walletid: rechargeData.walletId,
      title: `Recharge - ${rechargeData.operator} - ${rechargeData.number}`,
      operator: rechargeData.operator,
      number: rechargeData.number,
      wallet: rechargeData.wallet,
      description: rechargeData.note || "recharge",
      quantity,
      itemNo: rechargeData.itemNo,
      mrp: subunitAmount,
      saleprice: subunitAmount,
      soldprice: subunitAmount,
      baseprice: subunitAmount,
      taxpercentage: 0,
      discount: priceResult.discount,
      taxamount: priceResult.taxAmount,
      rechargeInfo: {
        wallet: {
          walletname: rechargeData.wallet,
        },
      },
      lineGrandTotal: priceResult.lineGrandTotal,
      lineTotalBasePrice: priceResult.lineTotalBasePrice,
      lineTotalDiscount: priceResult.lineTotalDiscount,
      lineTotalMrp: priceResult.lineTotalMrp,
      lineTotalSalePrice: priceResult.lineTotalSalePrice,
      lineTotalSoldPrice: priceResult.lineTotalSalePrice,
      lineTotalTaxAmount: priceResult.lineTotalTaxAmount,
    };

    setECart((prev) => {
      // Edit existing recharge
      if (
        typeof rechargeData.cIndex === "number" &&
        prev[rechargeData.cIndex]
      ) {
        return prev.map((item, index) =>
          index === rechargeData.cIndex ? newRecharge : item,
        );
      }

      // Add new recharge
      return [...prev, newRecharge];
    });
  };

  const applyOverallDiscount = () => {
    skipNextCartChange.current = true;
    hasApiOverallDiscount.current = true;
    const discount = Number(overallDiscount);

    setECart((items) => {
      if (!items.length) return items;

      originalPayableRef.current = totalSoldRes.grandtotal;
      originalItemsRef.current = structuredClone(items);

      skipNextGrandTotalChange.current = true;

      const lineItems = items.map((item) => ({
        soldPrice: item.soldprice,
        quantity: item.quantity,
        lineTotalSoldPrice: item.lineTotalSoldPrice,
      }));

      const distributedItems = distributeDiscountToItems(
        lineItems,
        CurrencyConverter.toSubunit(discount, "INR"),
        totalSoldRes.totalsaleprice,
      );

      return items.map((item, index) => {
        const newSoldPrice = distributedItems[index].soldPrice;

        const soldRes = PriceCalculator.getAllPriceList(
          item.mrp,
          newSoldPrice,
          item.baseprice,
          item.taxpercentage,
          item.quantity,
          "SALEPRICE",
        );

        return {
          ...item,
          soldprice: newSoldPrice,
          baseprice: soldRes.basePrice,
          discount: soldRes.discount,
          taxamount: soldRes.taxAmount,
          lineGrandTotal: soldRes.lineGrandTotal,
          lineTotalBasePrice: soldRes.lineTotalBasePrice,
          lineTotalDiscount: soldRes.lineTotalDiscount,
          lineTotalMrp: soldRes.lineTotalMrp,
          lineTotalSoldPrice: soldRes.lineTotalSalePrice,
          lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
        };
      });
    });

    setOverallDiscountApplied(true);
  };

  const removeOverallDiscount = () => {
    isOverallDiscountRemoved.current = true;
    hasApiOverallDiscount.current = false;
    skipNextCartChange.current = true;
    const restoredItems = structuredClone(originalItemsRef.current).map(
      (item) => {
        const quantity = item.quantity || 1;
        const soldPrice = item.soldprice;

        const soldRes = PriceCalculator.getAllPriceList(
          item.mrp,
          soldPrice,
          item.baseprice,
          item.taxpercentage,
          quantity,
          "SALEPRICE",
        );

        const salePrice = item.saleprice;

        const saleRes = PriceCalculator.getAllPriceList(
          item.mrp,
          salePrice,
          item.baseprice,
          item.taxpercentage,
          quantity,
          item.isLock,
        );

        return {
          ...item,
          quantity,
          soldprice: soldPrice,
          saleprice: salePrice,

          baseprice: soldRes.basePrice,
          discount: soldRes.discount,
          taxamount: soldRes.taxAmount,

          lineGrandTotal: soldRes.lineGrandTotal,
          lineTotalBasePrice: soldRes.lineTotalBasePrice,
          lineTotalDiscount: soldRes.lineTotalDiscount,
          lineTotalMrp: soldRes.lineTotalMrp,
          lineTotalSalePrice: saleRes.lineTotalSalePrice,
          lineTotalSoldPrice: soldRes.lineTotalSalePrice,
          lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
        };
      },
    );

    setECart(restoredItems);

    originalItemsRef.current = [];
    originalPayableRef.current = 0;

    setOverallDiscount("");
    setOverallDiscountApplied(false);
  };

  const resetOverallDiscount = () => {
    isOverallDiscountRemoved.current = true;
    hasApiOverallDiscount.current = false;

    if (!overallDiscountApplied) return;

    skipNextCartChange.current = true;

    const originalItems = structuredClone(originalItemsRef.current);

    setECart((currentCart) =>
      currentCart.map((item) => {
        const original = originalItems.find(
          (o) =>
            String(o._id) === String(item._id) &&
            o.mrp === item.mrp &&
            o.taxpercentage === item.taxpercentage,
        );

        // Newly added product
        if (!original) {
          return item;
        }

        // Keep user's latest quantity
        const quantity = item.quantity;

        // Keep user's latest sale price
        const salePrice = item.saleprice;

        // Restore only the original sold price (before overall discount)
        const soldPrice = original.soldprice;

        const soldRes = PriceCalculator.getAllPriceList(
          item.mrp,
          soldPrice,
          item.baseprice,
          item.taxpercentage,
          quantity,
          "SALEPRICE",
        );

        const saleRes = PriceCalculator.getAllPriceList(
          item.mrp,
          salePrice,
          item.baseprice,
          item.taxpercentage,
          quantity,
          item.isLock,
        );

        return {
          ...item,
          quantity,
          soldprice: soldPrice,
          saleprice: salePrice,
          baseprice: soldRes.basePrice,
          discount: soldRes.discount,
          taxamount: soldRes.taxAmount,
          lineGrandTotal: soldRes.lineGrandTotal,
          lineTotalBasePrice: soldRes.lineTotalBasePrice,
          lineTotalDiscount: soldRes.lineTotalDiscount,
          lineTotalMrp: soldRes.lineTotalMrp,
          lineTotalSalePrice: saleRes.lineTotalSalePrice,
          lineTotalSoldPrice: soldRes.lineTotalSalePrice,
          lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
        };
      }),
    );

    originalItemsRef.current = [];
    originalPayableRef.current = 0;
    setOverallDiscount("");
    setOverallDiscountApplied(false);
  };

  const handleCustomerModalOpen = () => {
    handleResetCustomer();
    setCustomerModalOpen(true);
  };

  const handleCustomerModalClose = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  // const handleCustomerNumbersuggestion = async () => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance("module/customer/suggestion/phone");
  //     const result = response.data.results;
  //     setNumberSuggest(result);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleCustomerAdd = async (newData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        shippingAddress: {
          addressline1: newData.shippingaddressline1,
          addressline2: newData.shippingaddressline2,
          district: newData.shippingdistrict,
          city: newData.shippingcity,
          state: newData.shippingstate,
          statecode: newData.shippingstatecode,
          country: newData.shippingcountry,
          pincode: newData.shippingpincode,
        },

        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      const response = await AxiosInstance.post(`module/customer`, data);
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      const result = response.data.results;
      if (result.name !== newData.name) {
        showAlert(
          "warning",
          `The phone number"${result.phone}" already exists .`,
        );
        // handleCloseModal();
        return true;
      }
      handleResetAddCustomer();
      handleSelectCustomer(response.data.results);
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const handleResetCustomer = () => {
    setCustomerSuggestions([]);
    setCustomerSearchTerm("");
  };

  const handleResetAddCustomer = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && customerSearchTerm.trim()) {
      handleCustomerModalOpen();
    }
  };

  // const handleEnterFocus = (e, nextRef) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     nextRef?.current?.focus();
  //   }
  // };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleUpdate(e);
    }
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        cashRef.current?.focus();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer.name.toLowerCase() === trimmedSearch.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  const addNewServiceName = (name) => {
    if (
      !serviceNameSuggest.some(
        (s) => s.serviceByName?.toLowerCase() === name?.toLowerCase(),
      )
    ) {
      setServiceNameSuggest((prev) => [
        { _id: Date.now(), serviceByName: name },
        ...prev,
      ]);
    }
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const handleNewGroupOpen = () => {
    setNewGroupOpen(true);
  };

  const handleCustomerGroupAdd = async (groupName, method) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/group", data);
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      if (method === "ADD") {
        handleCustomerModalOpen();
      } else {
        openEditModal(isEditData);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  useEffect(() => {
    const handleArrowAndEnter = (e) => {
      // Only handle when search term is empty or suggestions list is empty
      if (!(customerSearchTerm?.trim() === "")) return;
      if (!(customerSuggestions?.length === 0)) return;

      if (
        noteModalOpen ||
        isEditSalePriceModelOpen ||
        isEditRechargeModelOpen ||
        isRecharageModalOpen ||
        isEditServiceModalOpen ||
        isServiceModalOpen ||
        isProductModalOpen ||
        isEditModalOpen ||
        isCustomerModalOpen ||
        isChangeModalOpen ||
        isSaleModalOpen ||
        isSoldPirceModalOpen ||
        isQuantityModalOpen ||
        isStockModalOpen ||
        globelPopupOpen
      )
        return;

      if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

      e.preventDefault();

      const tableRows = Array.from(document.querySelectorAll("table tbody tr"));
      if (!tableRows.length) return;

      const currentRow = document.activeElement.closest("tr");
      let currentIndex = tableRows.indexOf(currentRow);

      // Handle Enter key
      if (e.key === "Enter") {
        if (currentIndex >= 0) {
          const item = tableRows[currentIndex].dataset.item
            ? JSON.parse(tableRows[currentIndex].dataset.item)
            : null;

          if (item) {
            if (item.imode === "SERVICE") {
              editItem(item, currentIndex);
            } else if (item.imode === "RECHARGE") {
              RechargeEdit(item, currentIndex);
            } else if (item.imode === "PRODUCT") {
              salepriceEdit(item, currentIndex);
            }
          }
        }
        return;
      }

      // Virtual -1: no row focused yet
      if (currentIndex === -1) {
        if (e.key === "ArrowDown") {
          tableRows[0].tabIndex = 0;
          tableRows[0].focus();
        } else if (e.key === "ArrowUp") {
          tableRows[tableRows.length - 1].tabIndex = 0;
          tableRows[tableRows.length - 1].focus();
        }
        return;
      }

      // Remove tabIndex from current row
      currentRow.tabIndex = -1;

      // Calculate next/previous index
      let nextIndex =
        e.key === "ArrowDown"
          ? (currentIndex + 1) % tableRows.length
          : (currentIndex - 1 + tableRows.length) % tableRows.length;

      const nextRow = tableRows[nextIndex];
      nextRow.tabIndex = 0;
      nextRow.focus();
    };

    window.addEventListener("keydown", handleArrowAndEnter);
    return () => window.removeEventListener("keydown", handleArrowAndEnter);
  }, [
    favouriteRefs,
    productSearchTerm,
    productSuggestions,
    noteModalOpen,
    isEditSalePriceModelOpen,
    isEditRechargeModelOpen,
    isRecharageModalOpen,
    isEditServiceModalOpen,
    isServiceModalOpen,
    isProductModalOpen,
    isEditModalOpen,
    isCustomerModalOpen,
    isChangeModalOpen,
    isSaleModalOpen,
    isSoldPirceModalOpen,
    isQuantityModalOpen,
    isStockModalOpen,
    customerSuggestions,
    customerSearchTerm,
    globelPopupOpen,
  ]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleSuggestEstimate();
    if (hasModulePermission("SERVICE") || permission === undefined) {
      handleSuggestService();
    }
    handleSuggestNote();
    fetchFavouriteProducts();
  }, []);

  useEffect(() => {
    // handleCustomerNumbersuggestion();

    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    const os = getOS();
    if (os === "macOS") {
      setShortcutKey("CMD + F");
    } else {
      setShortcutKey("Ctrl + F");
    }
  }, []);

  useEffect(() => {
    const savedOffer = localStorage.getItem("selectedOffer");
    const savedOfferEnabled = localStorage.getItem("offerEnabled");

    if (savedOffer) {
      setSelectedOffer(Number(savedOffer));
    }

    if (savedOfferEnabled !== null) {
      setOfferEnabled(savedOfferEnabled === "true");
    }
  }, []);

  useEffect(() => {
    if (isOverallDiscountRemoved.current) return;

    if (state?.overallDiscount && ecart.length > 0 && !overallDiscountApplied) {
      setOverallDiscount(
        CurrencyConverter.toCurrency(
          state?.overallDiscount?.overallDiscountAmount,
          "INR",
        ),
      );

      setOverallDiscountApplied(true);

      originalItemsRef.current = state?.saleitems?.map((item, index) => {
        const previous = state?.overallDiscount?.previousItemDetails[index];

        return {
          ...item,
          soldprice: previous?.soldPrice ?? item.soldprice,
          quantity: previous?.quantity ?? item.quantity,
          lineTotalSoldPrice:
            previous?.lineTotalSoldPrice ?? item.lineTotalSoldPrice,
        };
      });
    }
  }, [state?.overallDiscount, ecart]);
  // console.log("originalItemsRef.current", originalItemsRef.current);

  useEffect(() => {
    if (!viewOption("saleSettings", "isOffer")) {
      setOfferEnabled(false);
      setSelectedOffer(null);
    }
  }, [viewOption("saleSettings", "isOffer")]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    // handleSuggestEstimate();
    // handleCustomerNumbersuggestion()
    if (hasModulePermission("SERVICE") || permission === undefined) {
      handleSuggestService();
    }
  }, []);

  // useEffect(() => {
  //   console.log("state effect running");
  //   if (state?.saledate) {
  //     setSaleDate(dayjs(state.saledate));
  //     setSaleDateApi(state.saledate);
  //     setOriginalSaleDate(state.saledate);
  //   }
  // }, [state]);
  useEffect(() => {
    const payObject = {
      cashamount: CurrencyConverter.toSubunit(paymentData.cash || 0, "INR"),
      cardamount: CurrencyConverter.toSubunit(paymentData.card || 0, "INR"),
      onlineamount: CurrencyConverter.toSubunit(paymentData.online || 0, "INR"),
      upiamount: CurrencyConverter.toSubunit(paymentData.upi || 0, "INR"),
      paylateramount: CurrencyConverter.toSubunit(
        paymentData.paylater || 0,
        "INR",
      ),
      discountamount: 0,
    };

    const totalVal = TotalCalculator.validateCheckout(totalPayable, payObject);
    setBalance(totalVal.balance);
    setPaymentData((prev) => ({
      ...prev,
      totalPaid: totalVal.totalPaid,
      balance: totalVal.balance,
    }));
  }, [
    paymentData.cash,
    paymentData.card,
    paymentData.online,
    paymentData.upi,
    paymentData.paylater,
    totalPayable,
  ]);

  useEffect(() => {
    setCash(paymentData.cash || 0);
    setCard(paymentData.card || 0);
    setOnline(paymentData.online || 0);
    setUpi(paymentData.upi || 0);
    setPaylater(paymentData.paylater || 0);
    setTotalPaid(paymentData.totalPaid || 0);
    setBalance(paymentData.balance || 0);
  }, [paymentData]);

  useEffect(() => {
    if (skipNextCartChange.current) {
      skipNextCartChange.current = false;
      return;
    }

    if (!overallDiscountApplied) return;

    resetOverallDiscount();
  }, [ecart]);

  useEffect(() => {
    if (!isActive) return; // Only enable shortcut when tab is active

    const handleKeyDown = (event) => {
      const isModifier = event.ctrlKey || event.metaKey;

      if (isModifier && event.key.toLowerCase() === "f") {
        event.preventDefault();
        setFavouriteProductModel(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isActive]);

  const saveRemark = () => {
    const value = remarkInput.trim();

    setRemark(value);
    setRemarkInput(value);
  };

  const maxDiscount = CurrencyConverter.toCurrency(
    totalSoldRes.totalsaleprice || 0,
    "INR",
  );

  const isDiscountInvalid = Number(overallDiscount || 0) > maxDiscount;

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row py-0">
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-header bg-header  px-3 py-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex gap-2 flex-wrap">
                      <h6 className="mb-0 bg-text">
                        Edit Sale -{" "}
                        <span className="badge rounded-pill bg-label-star">
                          {saleNo}
                        </span>
                      </h6>
                      <div className="mb-0">
                        <div className="input-group w-200">
                          <button className="input-group-text">
                            <CalendarIcon />
                          </button>

                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              open={openDatePicker}
                              onOpen={() => setOpenDatePicker(true)}
                              onClose={() => setOpenDatePicker(false)}
                              disableOpenPicker
                              value={saleDate}
                              onChange={handleSaleDate}
                              format="DD MMM YYYY"
                              minDate={minDate} // last 5 months only
                              maxDate={maxDate} // no future dates
                              slotProps={{
                                textField: {
                                  size: "small",
                                  className: "form-control cursor-pointer",
                                  onClick: () => setOpenDatePicker(true),
                                  inputProps: { readOnly: true },
                                  onKeyDown: (e) => e.preventDefault(),
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-2 flex-wrap justify-content-end">
                      {/* <button
                        className="btn shadow-none bg-label-service"
                        onClick={() => handleProductOpen()}
                      >
                        <i className="ng ng-ng-add-icon"></i> Product
                      </button> */}
                      <button
                        className="btn shadow-none bg-label-service"
                        onClick={() => handleServiceOpen()}
                      >
                        <AddIcon /> Service
                      </button>
                      {activeStoreModules("RECHARGE") && (
                        <button
                          className="btn shadow-none bg-label-service"
                          onClick={() => handleRechargeOpen()}
                        >
                          <AddIcon /> Recharge
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body mt-3 py-0">
                    <div className="row g-2">
                      {viewOption("saleSettings", "isScanBarcode") && (
                        <div
                          className="col-sm-3"
                          style={{ position: "relative" }}
                        >
                          <div className="input-group">
                            <button className="input-group-text">
                              <BarcodeIcon />
                            </button>
                            <input
                              type="text"
                              className="form-control createdon"
                              name="barcodeSearch"
                              ref={barcodeRef}
                              value={barcodeSearchTerm}
                              onChange={(e) =>
                                setBarcodeSearchTerm(e.target.value)
                              }
                              onKeyDown={handleBarcodeKeyDown}
                              placeholder="Scan Barcode"
                              autoFocus
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className="col-sm-4"
                        style={{ position: "relative" }}
                      >
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            name="search"
                            ref={suggestionsRef}
                            autoComplete="off"
                            value={productSearchTerm}
                            onChange={(e) => {
                              const value = e.target.value;

                              // ✅ FIX 4: detect delete
                              if (value.length < productSearchTerm.length) {
                                setHighlightedIndex(0);
                              }

                              setProductSearchTerm(value);

                              setProductSuggestions([]); // (from Fix 1 - important)
                              setShowProductDropdown(true);

                              handleProductSearch(value);
                            }}
                            onKeyDown={handleProductKeyDown}
                            onFocus={() => {
                              if (productSuggestions.length > 0) {
                                setShowProductDropdown(true);
                              }
                            }}
                            placeholder="Search products ..."
                            autoFocus
                          />
                          <button className="input-group-text">
                            <SearchIcon />
                          </button>
                        </div>
                        {productSearchTerm &&
                          productSuggestions.length === 0 && (
                            <ul className="suggestions-list">
                              <li className="suggestion-item text-muted">
                                No products data was found
                              </li>
                            </ul>
                          )}
                        {showProductDropdown &&
                          productSuggestions.length > 0 && (
                            <ProductSearchList
                              suggest={productSuggestions}
                              suggestionRefs={suggestionRefs}
                              handleSelect={handleSelectProduct}
                              activeIndex={highlightedIndex}
                            />
                          )}
                      </div>

                      <div className="col d-flex justify-content-end gap-2">
                        {/* Offer Dropdown */}
                        {viewOption("saleSettings", "isOffer") && (
                          <Tooltip title="Sale Price Offer" arrow>
                            <div className="btn-group">
                              {/* LEFT BUTTON (Enable / Disable Offer) */}
                              <button
                                type="button"
                                className={`btn border-0 ${
                                  offerEnabled
                                    ? "btn-warning text-dark"
                                    : "btn-offer-disabled"
                                }`}
                                onClick={() => {
                                  const newValue = !offerEnabled;
                                  setOfferEnabled(newValue);

                                  localStorage.setItem(
                                    "offerEnabled",
                                    newValue,
                                  );
                                }}
                              >
                                <OfferIcon />{" "}
                                {selectedOffer ? `${selectedOffer}%` : ""}
                              </button>

                              {/* RIGHT DROPDOWN BUTTON */}
                              <button
                                type="button"
                                className={`btn dropdown-toggle dropdown-toggle-split ${
                                  offerEnabled
                                    ? "btn-warning text-dark"
                                    : "btn-offer-disabled"
                                }`}
                                data-bs-toggle="dropdown"
                                onClick={() => {
                                  if (!offerEnabled) {
                                    setOfferEnabled(true);
                                    localStorage.setItem("offerEnabled", true);
                                  }
                                }}
                              >
                                {/* <span className="visually-hidden">
                                                      Toggle Dropdown
                                                    </span> */}
                              </button>

                              {/* DROPDOWN MENU */}
                              <ul className="dropdown-menu">
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(10)}
                                  >
                                    10%
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(20)}
                                  >
                                    20%
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(35)}
                                  >
                                    35%
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(50)}
                                  >
                                    50%
                                  </button>
                                </li>

                                <li>
                                  <hr className="dropdown-divider" />
                                </li>

                                <li className="px-3 py-2">
                                  <input
                                    step="0.01"
                                    max="99.99"
                                    min="0"
                                    placeholder="Custom %"
                                    className="form-control form-control-sm"
                                    onBlur={(e) => {
                                      const value = e.target.value;
                                      if (!value) return;

                                      const formatted = Number(
                                        parseFloat(value).toFixed(2),
                                      );
                                      handleOfferSelect(formatted);
                                    }}
                                  />
                                </li>
                              </ul>
                            </div>
                          </Tooltip>
                        )}

                        {/* Favourite Button */}
                        {uRLs.FAVOURITE_SALE === "true" && (
                          <Tooltip title={shortcutKey} arrow>
                            <span>
                              <button
                                className="btn shadow-none btn-label-primary"
                                onClick={() => handleListFavouriteProductOpen()}
                              >
                                <StarIcon iClass={"text-warning"} /> Favourites
                              </button>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-body px-0">
                    <div
                      className="table-responsive mt-0"
                      style={{
                        maxHeight: "500px",
                        overflowY: "auto",
                        msOverflowStyle: "none",
                        scrollbarWidth: "thin",
                        overflowX: "hidden",
                      }}
                    >
                      <table className="table table-bordered align-middle mb-0">
                        <thead
                          className="table-light"
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                          }}
                        >
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="w-30">Description</th>
                            <th className="text-center">MRP</th>
                            <th className="text-center">Discount</th>
                            <th className="text-center">Sale Price</th>
                            <th className="text-center w-15">Qty</th>
                            <th className="text-center">Total</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ecart.map((item, index) => (
                            <tr
                              key={item.imode + index}
                              className="position-relative  cursor-poInter hover-row"
                              onClick={() => {
                                if (item.imode === "SERVICE") {
                                  editItem(item, index);
                                } else if (item.imode === "RECHARGE") {
                                  RechargeEdit(item, index);
                                } else if (item.imode === "PRODUCT") {
                                  salepriceEdit(item, index);
                                }
                              }}
                              data-item={JSON.stringify(item)}
                            >
                              <td className="text-center">
                                {index + 1}
                                {item.imode === "SERVICE" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-yellow"} />
                                  </span>
                                )}
                                {item.imode === "RECHARGE" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-yellow"} />
                                  </span>
                                )}
                                {item.imode === "PRODUCT" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-primary"} />
                                  </span>
                                )}
                              </td>
                              <td className="text-wrap" width="280">
                                {item.title} - &nbsp;
                                <small className="badge rounded-pill bg-label-peace">
                                  {" "}
                                  {item.taxpercentage}%
                                </small>
                                {item.imode === "SERVICE" && (
                                  <div className="ms-0 fs-12">
                                    {item.description}
                                  </div>
                                )}
                                {item.imode === "PRODUCT" && (
                                  <div className="ms-0 fs-12 text-truncate-description text-muted d-flex align-items-start">
                                    <button
                                      type="button"
                                      className="me-2 rounded btn-label-primary shadow-none border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleProductNote(item);
                                      }}
                                    >
                                      <NotepadIcon />
                                    </button>
                                    {item.note && <span>{item.note}</span>}
                                  </div>
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.mrp || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.discount || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.soldprice || 0,
                                  "INR",
                                )}
                              </td>
                              <td width={120}>
                                {item.imode === "SERVICE" ||
                                item.imode === "RECHARGE" ? (
                                  <span className="text-center d-block">
                                    {item.quantity} {item?.unit}
                                  </span>
                                ) : (
                                  // <input
                                  //   type="text"
                                  //   value={item.quantity}
                                  //   onFocus={(e) => {
                                  //     e.stopPropagation();
                                  //     handleQuantity(item, index);
                                  //   }}
                                  //   className="form-control text-center w-120"
                                  //   min="1"
                                  // />
                                  <div className="text-center">
                                    {item.quantity} {item?.unit}{" "}
                                  </div>
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.lineGrandTotal || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                <div className="order-actions ">
                                  {item.imode === "SERVICE" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          editItem(item, index);
                                        }}
                                      >
                                        <EditIcon />
                                      </button>
                                    </>
                                  )}
                                  {item.imode === "RECHARGE" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          RechargeEdit(item, index);
                                        }}
                                      >
                                        <EditIcon />
                                      </button>
                                    </>
                                  )}
                                  {item.imode === "PRODUCT" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          salepriceEdit(item, index);
                                        }}
                                      >
                                        <EditIcon />
                                      </button>
                                    </>
                                  )}
                                  <button
                                    className="btn-label-danger shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeEItem(index);
                                    }}
                                  >
                                    <DeleteIcon />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="row bg-light border-0 mt-2 text-center align-items-center m-0">
                      <div className="col p-2">
                        <p className="mb-0">Total MRP</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalmrp || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <MinusIcon iClass={"text-muted"} />
                      </div>
                      <div className="col p-2">
                        <p className="mb-0">Total Discount</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totaldiscount || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <LineDoubleIcon iClass={"text-muted"} />
                      </div>
                      <div className="col bg-dark-purple p-2">
                        <p className="mb-0 bg-dark-purple">Total Amount</p>
                        <h6 className="mb-0 bg-dark-purple fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalsaleprice || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <LineDoubleIcon iClass={"text-muted"} />
                        <ChevronRightIcon iClass={"text-muted"} />
                      </div>
                      <div className="col bg-dark-blue p-2">
                        <p className="mb-0 bg-dark-text">
                          Grand Total <small className="fs-14">(Rounded)</small>
                        </p>
                        <h6 className="mb-0 bg-dark-text fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.grandtotal || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    {!selectedCustomer && (
                      <div className="ms-auto position-relative">
                        <SearchInput
                          searchRef={customerSuggestionsRef}
                          value={customerSearchTerm}
                          onChange={(e) => {
                            handleCustomerSearch(e.target.value);
                            setShowCustomerDropdown(true);
                            setHighlightedIndex(-1);
                          }}
                          onFocus={() => {
                            if (customerSuggestions.length > 0) {
                              setShowCustomerDropdown(true);
                            }
                          }}
                          onSearch={
                            customerSearchTerm.trim()
                              ? () =>
                                  handleCustomerModalOpen(
                                    customerSearchTerm.trim(),
                                  )
                              : null
                          }
                          onKeyPress={handleKeyPress}
                          placeholder="Search customer by name, phone, email, referenceID..."
                          onKeyDown={handleCustomerKeyDown}
                        />
                        {customerSearchTerm &&
                          customerSuggestions.length === 0 && (
                            <ul className="suggestions-list">
                              <li className="suggestion-item text-muted">
                                No customers data was found
                              </li>
                            </ul>
                          )}
                        {showCustomerDropdown &&
                          customerSuggestions.length > 0 && (
                            <ProductSearchList
                              suggest={customerSuggestions}
                              suggestionRefs={suggestionRefs}
                              handleSelect={handleSelectCustomer}
                              activeIndex={highlightedIndex}
                              type="customer"
                            />
                          )}
                      </div>
                    )}

                    <div className="col-lg-12 mt-1">
                      <div className="card shadow-none border-blue mb-0">
                        <div className="card-header bg-label-infoss p-2 d-flex justify-content-between align-items-center">
                          <div className="mb-0">Customer Info</div>
                          {selectedCustomer?.customerData && (
                            <div>
                              <button
                                type="button"
                                className="btn-label-primary rounded shadow-none border-0"
                                onClick={() =>
                                  openEditModal(selectedCustomer.customerData)
                                }
                              >
                                <EditIcon />
                              </button>

                              <button
                                type="button"
                                className="btn-label-danger rounded shadow-none border-0 cursor-pointer"
                                onClick={handleRemoveCustomer}
                              >
                                <RemoveIcon />
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="card-body px-2 py-0">
                          {selectedCustomer ? (
                            <>
                              <p className="my-1 fs-13">
                                Name :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer.customerData.name}
                                </span>
                              </p>
                              <p className="my-1 fs-13">
                                Phone :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer.customerData.phone}{" "}
                                </span>
                              </p>
                              {selectedCustomer?.customerData?.gstnumber && (
                                <p className="my-1 fs-13">
                                  GST :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.customerData?.gstnumber}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.customerData?.addressline1 && (
                                <p className="my-1 fs-13">
                                  Address :{" "}
                                  <span className="fw-600 fs-14">
                                    {
                                      selectedCustomer?.customerData
                                        ?.addressline1
                                    }
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.customerData?.state && (
                                <p className="my-1 fs-13">
                                  State:{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.customerData?.state}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer.customerData.referenceid && (
                                <p className="my-1 fs-13">
                                  Reference ID :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer.referenceid}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.paylaterData?._id && (
                                <p className="my-1 fs-13">
                                  Pay Later Balance :{" "}
                                  <span
                                    className={`fw-600 fs-14 ${
                                      selectedCustomer.paylaterData
                                        .closeamount < 0
                                        ? "badge bg-label-danger rounded-pill"
                                        : "badge bg-label-success text-success rounded-pill"
                                    }`}
                                  >
                                    {CurrencyConverter.toCurrency(
                                      selectedCustomer.paylaterData
                                        .closeamount || 0,
                                      "INR",
                                    )}
                                  </span>
                                </p>
                              )}
                            </>
                          ) : (
                            <p className="my-2 text-muted">
                              No customers has been selected
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {uRLs.PROJECT === "true" &&
                  activeStoreModules("PROJECT") &&
                  (hasModulePermission("PROJECT") ||
                    permission === undefined) && (
                    <div>
                      <ProjectSale
                        isActive={isActive}
                        onSelectProject={setProjectId}
                        resetProject={resetProject}
                        selectedProjectId={projectId}
                      />
                    </div>
                  )}
                {viewOption("saleSettings", "isRemark") && (
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="d-flex align-items-center mb-2"
                        style={{
                          color: "#16a34a",
                          // fontWeight: "600",
                          // fontSize: "13px",
                        }}
                      >
                        <NotepadIcon iClass={"me-1 font-16"} />
                        <h8 className="mb-0"> Remark</h8>
                        {remark?.trim() && (
                          <div className="ms-auto">
                            <button
                              type="button"
                              className="btn-label-primary rounded shadow-none border-0 cursor-pointer"
                              onClick={() => {
                                setRemarkModalOpen(true);
                              }}
                            >
                              <EditIcon />
                            </button>
                          </div>
                        )}
                      </div>

                      {!remark?.trim() ? (
                        <textarea
                          className="form-control"
                          rows={3}
                          placeholder="Enter remark..."
                          value={remarkInput}
                          onChange={(e) => setRemarkInput(e.target.value)}
                          onBlur={saveRemark}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              saveRemark();
                              e.target.blur(); // optional: removes focus after saving
                            }
                          }}
                        />
                      ) : (
                        <>
                          <div
                            style={{
                              color: "#4b5563",
                              fontSize: "12px",
                              lineHeight: "1.6",
                              wordBreak: "break-word",
                              ...(showFullRemark
                                ? {}
                                : {
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }),
                            }}
                          >
                            {capitalizeFirstLetter(remark)}
                          </div>

                          {remark.length > 120 && (
                            <span
                              onClick={() => setShowFullRemark(!showFullRemark)}
                              style={{
                                color: "#2563eb",
                                fontSize: "12px",
                                cursor: "pointer",
                                fontWeight: "500",
                              }}
                            >
                              {showFullRemark ? "Show Less" : "...more"}
                            </span>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}

                {viewOption("saleSettings", "isOverallDiscount") && (
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                          <h8 className="mb-0">Overall Discount :</h8>
                        </div>
                        <div style={{ width: "160px" }}>
                          <div className="position-relative">
                            <input
                              type="text"
                              disabled={overallDiscountApplied}
                              className="form-control text-center pe-4"
                              value={overallDiscount}
                              onChange={(e) => {
                                const value = e.target.value;

                                if (value === "") {
                                  setOverallDiscount("");
                                  return;
                                }

                                if (!/^\d*\.?\d*$/.test(value)) return;

                                setOverallDiscount(value);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();

                                  if (
                                    !isDiscountInvalid &&
                                    !overallDiscountApplied &&
                                    Number(overallDiscount) > 0
                                  ) {
                                    applyOverallDiscount();
                                  }
                                }
                              }}
                            />

                            {overallDiscount &&
                              Number(overallDiscount) > 0 &&
                              (overallDiscountApplied ? (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label-danger position-absolute top-50 end-0 translate-middle-y me-1 p-1 d-flex align-items-center justify-content-center  shadow-none"
                                  style={{ width: "26px", height: "26px" }}
                                  onClick={removeOverallDiscount}
                                >
                                  <XIcon iClass={"fs-5"} />
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className={`btn btn-sm position-absolute top-50 end-0 translate-middle-y me-1 p-1 d-flex align-items-center justify-content-center  shadow-none ${
                                    isDiscountInvalid
                                      ? "btn-secondary disabled"
                                      : "btn-label-success"
                                  }`}
                                  style={{ width: "26px", height: "26px" }}
                                  onClick={() => {
                                    if (
                                      !isDiscountInvalid &&
                                      !overallDiscountApplied
                                    ) {
                                      applyOverallDiscount();
                                    }
                                  }}
                                >
                                  <CheckIcon iClass={"fs-5"} />
                                </button>
                              ))}
                          </div>

                          {isDiscountInvalid && (
                            <small className="text-danger d-block mt-1">
                              Discount cannot be greater than ₹
                              {CurrencyConverter.toCurrency(
                                totalSoldRes.grandtotal || 0,
                                "INR",
                              )}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="card mb-6">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total MRP :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "14px" }}>
                        {formatCurrencyFun(totalSoldRes?.totalmrp)}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total Discount :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "14px" }}>
                        {formatCurrencyFun(totalSoldRes?.totaldiscount)}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total Amount :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "14px" }}>
                        {formatCurrencyFun(totalSoldRes?.totalsaleprice)}
                      </h6>
                    </div>
                    <div className="bg-light rounded p-2 text-center mb-3">
                      <h6 className="mb-0 fs-18 text-dark">
                        Total Payable :{" "}
                        <span>
                          {" "}
                          {formatCurrencyFun(totalSoldRes.grandtotal)}{" "}
                        </span>
                      </h6>
                    </div>
                    {/* <div className="d-flex justify-content-between align-items-center">
                                      <p className="mb-0" style={{ fontSize: "13px" }}>
                                        Total Product :
                                      </p>
                                      <h6 className="mb-0 fs-20" style={{ fontSize: "13px" }}>
                                        ₹ {CurrencyConverter.toCurrency(
                                          totalSoldRes?.grandtotal || 0,
                                          "INR",
                                        )}
                                      </h6>
                                    </div> */}
                    <div className="modal-footer d-block mt-3">
                      <button
                        type="button"
                        className="btn shadow-none btn-outline-secondary text-left"
                        onClick={handleCancel}
                      >
                        <XIcon /> Clear
                      </button>
                      {isBtnLoading ? (
                        <button
                          className="btn btn-primary pb-0 text-right"
                          disabled
                        >
                          <CircularProgress size={22} className="text-white" />
                        </button>
                      ) : (
                        <button
                          ref={buttonRef}
                          type="button"
                          className="btn btn-primary text-right w-48"
                          onClick={() => setPaymentModal(true)}
                        >
                          <CheckIcon /> Save
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <PaymentMethod
            open={paymentModal}
            paymentData={paymentData}
            setPaymentData={setPaymentData}
            totalPayable={totalPayable}
            onDone={() => handleUpdate(paymentData)}
            onClose={handlePaymentClose}
            handleFocusFill={handleFocusFill}
            handleEnterFocus={handleEnterFocus}
          />

          {isQuantityModalOpen && (
            <EditUpdateQty
              data={isQuantityData}
              updateIndex={isEditCartIndex}
              updateQuantity={handleQuantityUpdate}
              onClose={handleQuantityClose}
            />
          )}

          {isAlertModalOpen && <EditAlert onClose={handleAlertClose} />}

          {isChangeModalOpen && (
            <ChangeModal
              changeAmount={balance}
              onClose={handleChangeModalClose}
              onConfirm={handleChangeConfirm}
            />
          )}

          {isServiceModalOpen && (
            <AddService
              isActive={isActive}
              onClose={handleServiceClose}
              onAdd={UpdateServiceToCart}
              isBtnLoading={isBtnLoading}
              estimateSuggest={estimateSuggest}
              serviceNameSuggests={serviceNameSuggest}
              addNewServiceName={addNewServiceName}
              isServiceName={true}
              showQuanity={true}
            />
          )}

          {isEditServiceModalOpen && (
            <EditService
              onClose={handleEditServiceClose}
              onUpdate={UpdateServiceToCart}
              editData={isServiceData}
              isBtnLoading={isBtnLoading}
              estimateSuggest={estimateSuggest}
              serviceNameSuggests={serviceNameSuggest}
              addNewServiceName={addNewServiceName}
              isServiceName={true}
              showQuanity={true}
            />
          )}

          {isRecharageModalOpen && (
            <AddRecharge
              onClose={handleRechargeClose}
              onAdd={addRechargeToCart}
              isBtnLoading={isBtnLoading}
              // rechargeSuggest={[]}
            />
          )}

          {isEditRechargeModelOpen && (
            <EditRecharge
              editData={isEditRechargeData}
              onClose={handleEditRechargeClose}
              onAdd={addRechargeToCart}
              isBtnLoading={isBtnLoading}
            />
          )}

          {/* {isCustomerModalOpen && (
        <CustomerModal
          onClose={handleCustomerModalClose}
          onConfirm={handleCustomerAdd}
          onData={isCustomerData}
          isBtnLoading={isBtnLoading}
          groupName={groupName}
          onNewGroupsIn={handleCustomerGroupAdd}
          newGroup={newGroupName}
        />
      )} */}

          {isStockModalOpen && (
            <FindStock
              data={isStockData}
              recent={recentData}
              addToCart={addProductToCart}
              onClose={handleStockClose}
              offer={offerEnabled ? selectedOffer : null}
              customerSearchTerm={customerSearchTerm}
              customerSuggestions={customerSuggestions}
              highlightedIndex={highlightedIndex}
              showCustomerDropdown={showCustomerDropdown}
              selectedCustomer={selectedCustomer}
              suggestionRefs={suggestionRefs}
              customerSuggestionsRef={customerSuggestionsRef}
              handleCustomerSearch={handleCustomerSearch}
              handleSelectCustomer={handleSelectCustomer}
              handleCustomerKeyDown={handleCustomerKeyDown}
              handleKeyPress={handleKeyPress}
              setShowCustomerDropdown={setShowCustomerDropdown}
            />
          )}

          {isSoldPirceModalOpen && (
            <UpdatePrice
              data={isProductData}
              addToCart={addProductToCart}
              onClose={handleSoldPriceClose}
              offer={offerEnabled ? selectedOffer : null}
              customerSearchTerm={customerSearchTerm}
              customerSuggestions={customerSuggestions}
              highlightedIndex={highlightedIndex}
              showCustomerDropdown={showCustomerDropdown}
              selectedCustomer={selectedCustomer}
              suggestionRefs={suggestionRefs}
              customerSuggestionsRef={customerSuggestionsRef}
              handleCustomerSearch={handleCustomerSearch}
              handleSelectCustomer={handleSelectCustomer}
              handleCustomerKeyDown={handleCustomerKeyDown}
              handleKeyPress={handleKeyPress}
              setShowCustomerDropdown={setShowCustomerDropdown}
            />
          )}

          {isEditSalePriceModelOpen && (
            <UpdatePrice
              data={isEditSalePriceData}
              addToCart={addProductToCart}
              onClose={editSalePriceClose}
            />
          )}

          {isDeleteModalOpen && (
            <DeleteModal
              onClose={() => setDeleteModalOpen(false)}
              onConfirm={() => handleDelete()}
              isLable={" Sale " + isDeleteData?.saleno}
              isBtnLoading={isBtnLoading}
            />
          )}

          <AddCustomer
            isOpen={isCustomerModalOpen}
            onClose={handleCustomerModalClose}
            onData={isCustomerData}
            onAdd={handleCustomerAdd}
            isBtnLoading={isBtnLoading}
            groupName={groupName}
            onNewGroupsIn={handleCustomerGroupAdd}
            newGroup={newGroupName}
            resetAll={true}
            error={error}
            setErrors={setErrors}
            numberSuggest={numberSuggest}
            addNewCustomNumber={addNewCustomNumber}
          />

          {isEditModalOpen && (
            <EditCutomer
              editData={isEditData}
              onClose={closeEditModal}
              onEdit={handleUpdte}
              isBtnLoading={isBtnLoading}
              groupName={groupName}
              groupId={selectedCustomer?.customerData?.groupid}
              onNewGroupsIn={handleCustomerGroupAdd}
              resetAll={true}
              newGroup={newGroupName}
              error={error}
              setErrors={setErrors}
            />
          )}

          {noteModalOpen && (
            <ProductNoteModal
              onClose={handleProductNoteClose}
              onSave={saveProductNote}
              initialNote={currentNoteProduct?.note || ""}
            />
          )}

          {isFavouriteProductModel && (
            <ListFavouriteProduct
              onClose={handleListFavouriteProductClose}
              handleAddClick={handleAddClick}
              listFavouriteProducts={favouriteProducts}
              loading={loading}
              favouriteProductsData={(updatedList) => {
                setFavouriteProducts(updatedList);
              }}
            />
          )}

          {!templateId && isViewModalOpen && (
            <InvoiceTempPreview
              isData={data}
              onClose={() => setViewModalOpen(false)}
              onAdd={handleSetTemplate}
            />
          )}
          {templateId && isSaleModalOpen && (
            <TemplateModalLayout
              isOpen={isSaleModalOpen}
              isData={data}
              onClose={handleClose}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              setSaleData={setSaleDataEdit}
              isActive={isActive}
            />
          )}
          <RemarkModal
            open={remarkModalOpen}
            initialValue={remark}
            onClose={() => setRemarkModalOpen(false)}
            onSave={(val) => {
              setRemark(val);
              setRemarkInput(val);
              setRemarkModalOpen(false);
            }}
          />
        </div>
      </div>
    </>
  );
};
export default EditSale;
